import React, { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import CompanyCard from '../components/CompanyCard';
import { companies } from '../data/companies';
import styles from './newPortfolio.module.css';

function NewPortfolio() {
  const [shuffledCompanies, setShuffledCompanies] = useState([]);

  useEffect(() => {
    // Shuffle companies array on component mount
    const shuffled = [...companies].sort(() => Math.random() - 0.5);
    setShuffledCompanies(shuffled);
  }, []);

  // Structured data for portfolio page
  const portfolioStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Portfolio - Sapienta VC",
    "description": "Explore Sapienta VC's portfolio of ambitious projects and startups across diverse sectors. See how we help companies achieve accelerated growth and market leadership.",
    "url": "https://sapienta.vc/newportfolio",
    "mainEntity": {
      "@type": "Organization",
      "name": "Sapienta VC",
      "hasCredential": companies.map(company => ({
        "@type": "OrganizationRole",
        "roleName": "Investor",
        "organization": {
          "@type": "Organization",
          "name": company.name,
          "description": company.description || `Portfolio company of Sapienta VC`
        }
      }))
    }
  };


  return (
    <div className={styles.container}>
      <SEO
        title="Portfolio - Sapienta VC Investment Portfolio"
        description="Explore Sapienta VC's portfolio of ambitious projects and startups across diverse sectors. Strategic investment in AI, fintech, and technology companies."
        keywords="sapienta portfolio, startup portfolio, venture capital investments, portfolio companies, AI startups, fintech investments"
        url="https://sapienta.vc/newportfolio"
        structuredData={portfolioStructuredData}
      />

      <div className={styles.description}>
        <p>Through strategic investment and hands-on guidance, we have helped companies achieve accelerated growth and market leadership across diverse sectors.</p>
      </div>

      <main className={styles.main}>
        <div className={styles.portfolioGrid}>
          {shuffledCompanies.map((company, index) => (
            <CompanyCard
              key={index}
              name={company.name}
              description={company.description}
              image={company.image}
              website={company.website}
            />
          ))}
        </div>
      </main>

      <footer className={styles.footer}>
        <h3>Portfolio Overview</h3>
        <p>Our portfolio represents our commitment to backing ambitious founders building transformative companies. Through strategic investment and hands-on guidance, we focus on three core areas: Payment Innovation, Technology Excellence, and AI-Driven Solutions that leverage cutting-edge technology to transform industries.</p>
        <p>For investment opportunities or partnership inquiries, contact us at info@sapienta.vc</p>
      </footer>
    </div>
  );
}

export default NewPortfolio;